const getAlertBannerOffset = (
	showTop: boolean | undefined,
	showBottom: boolean | undefined,
	bothValue: string,
	oneValue: string
): string | undefined => {
	if (showTop && showBottom) return bothValue;
	if (showTop || showBottom) return oneValue;
	return undefined;
};

const calculateMinHeight = (
	showMobileHeaderLocationBar: boolean | null | undefined,
	baseXs: string,
	baseMd: string,
	additionalXs?: string,
	additionalMd?: string
) => {
	const xsBase = showMobileHeaderLocationBar ? baseXs : '4rem';
	return {
		xs: additionalXs ? `calc(${xsBase} + ${additionalXs})` : xsBase,
		md: additionalMd ? `calc(${baseMd} + ${additionalMd})` : baseMd,
	};
};

export const getMinHeaderHeightStyles = (
	showMobileHeaderLocationBar?: boolean | null,
	showTopAlertBannerMessagesMobile?: boolean,
	showBottomAlertBannerMessagesMobile?: boolean,
	showTopAlertBannerMessagesDesktop?: boolean,
	showBottomAlertBannerMessagesDesktop?: boolean
) => {
	const baseXs = '7.25rem';
	const baseMd = '8.75rem';

	const additionalXs = getAlertBannerOffset(
		showTopAlertBannerMessagesMobile,
		showBottomAlertBannerMessagesMobile,
		'5.8rem',
		'2.825rem'
	);
	const additionalMd = getAlertBannerOffset(
		showTopAlertBannerMessagesDesktop,
		showBottomAlertBannerMessagesDesktop,
		'5.8rem',
		'2.825rem'
	);

	return {
		minHeight: calculateMinHeight(showMobileHeaderLocationBar, baseXs, baseMd, additionalXs, additionalMd),
	};
};

export const getHeaderWrapperStyles = (
	showMobileHeaderLocationBar?: boolean | null,
	showTopAlertBannerMessagesMobile?: boolean,
	showBottomAlertBannerMessagesMobile?: boolean,
	showTopAlertBannerMessagesDesktop?: boolean,
	showBottomAlertBannerMessagesDesktop?: boolean
) => ({
	width: '100vw',
	...getMinHeaderHeightStyles(
		showMobileHeaderLocationBar,
		showTopAlertBannerMessagesMobile,
		showBottomAlertBannerMessagesMobile,
		showTopAlertBannerMessagesDesktop,
		showBottomAlertBannerMessagesDesktop
	),
	backgroundColor: 'backgrounds.white',
});
